import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import { translate, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import RoomsContainer from './Reservation/RoomContainer.js';
import Room from './Reservation/Room.js';
import PaymentContainer from './Payment/PaymentContainer.js';


import CoworkedContainer from './Cowork/CoworkContainer.js';
import CoworkMoreInfo from './Cowork/Cowork'
import PaymentDomicilioContainerCowork from './Cowork/Payment/PaymentDomicilioContainerCowork.js'
import CardCoworkConatiner from './Cowork/Payment/CardCoworkConatiner.js';

import AgradecimientoContainer from './AgradecimientoContainer.js'


import DomicilioContainer from './Domicilio/DomicilioContainer.js';
import DomicilioId from './Domicilio/DomicilioId.js';
import PaymentDomicilioContainer from './Domicilio/Payment/PaymentDomicilioContainer.js';
import CardDomicilioConatiner from './Domicilio/Payment/CardDomicilioConatiner.js'

import HelpContainer from './HelpContainer';

import brandLogo from './../images/banner.jpeg';

// Images
import salasImg from './../images/salas_de_juntas.jpeg';
import coworkImg from './../images/cowork.jpeg';
import domicilioImg from './../images/domicilio_comercial.png';
import Header from '../components/Header/index.jsx';
import NotFound from './404/index.jsx';

let cancelToken;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class NewStoreContainer extends Component {

    getInitState = () => {
        return {
            is_Cowork: false,
            is_Sala: false,
            is_domicilio: false,
            center: null,
            centerQuery: "",
            centers: [],
            cuidad: [],
            city: "",
            user: {
                no_account: true
            },
            shouldRedirect: false,
            is_touch_device: window.matchMedia("(pointer: coarse)").matches,
            touchActive: null
        };
    }

    constructor(props) {
        super(props);
        this.state = this.getInitState();
    }
    goBack = () => {
        this.props.history.goBack();
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        // $(window).off("resize", this.resize);
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    componentDidMount() {
        this.getCenters({
            token_id: this.props.getTokenId()
        });
    }

    getTokenSession = () => {
        // No aplica para usuario sin cuenta
        return "";
    }

    reload = () => {
        this.getCities({
            token_id: this.props.getTokenId()
        });
    }

    getCities = (params) => {
        this.props.post(
            "/getCities",
            params,
            (cuidad) => this.setState({ cuidad }),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getCenters = (params) => {
        this.props.postStore(
            "/getListCenter",
            params,
            (centers) => {
                this.setState({ centers });
                // this.handleOptionUpdate();
            },
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    handleOptionUpdate = () => {
        if ($("#center-results").children().length) {
            $("#center-results").css("display", "");
        } else {
            $("#center-results").css("display", "none");
        }
    }

    handleCenterClick = (center) => {
        this.setState({
            center: center,
            centerQuery: center.name
        });
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    renderCenter = (center, index) => {
        return (
            <li key={index}>
                <a onClick={() => this.handleCenterClick(center)}>
                    {center.name}
                </a>
            </li>
        );
    }

    handleIsSala = (params) => {
        this.setState({
            is_Sala: true,
        });
    }

    handleIsCowork = (params) => {
        this.setState({
            is_Cowork: true,
        });
    }

    handleBack = (params) => {
        this.setState({
            is_Cowork: false,
            is_Sala: false,
            is_domicilio: false,
        });
    }

    handleErrorResponse = (error) => {
        console.error(error)
    }

    handleTouch = (e, state) => {
        if (this.state.is_touch_device) {
            // verify object with key 
            const [key] = Object.keys(state);
            console.log(key)
            if (this.state.touchActive === key) {
                this.setState({ touchActive: null, ...state });

            } else {
                this.setState({ touchActive: key });
            }
        } else {
            this.setState(state);
        }
    }
    handleOnBlur = (e) => {
        this.setState({ touchActive: null });
    }



    handleCenterSearch = (event) => {
        const data = JSON.parse(event.target.value);
        this.setState({
            centerQuery: data.name,
            center: data
        });
        console.log(data)
    }

    renderSelectMenu = () => {
        // const [, setIsHovered] = useState(false);
        // const { t } = this.props;
        return (
            <div>
                <div className="container-desktop">
                    <div className="container-desktop_store ">
                        <section onClick={(e) => this.handleTouch(e, {
                            is_Cowork: true,
                        })}>
                            <div className="container_tarjet_store_desktop col-md-4" style={{
                                backgroundImage: `url(${coworkImg})`
                            }}>
                                <span className="text_card_hover_hover">
                                    <h2 className="text-primary text-heding">
                                        <Trans>venta_linea.index.cowork.title</Trans>
                                    </h2>
                                    <p className="text-primary text-container">
                                        <Trans>venta_linea.index.cowork.subtitle</Trans>
                                    </p>
                                    <p className="text-primary text-buttom">
                                        <Trans i18nKey='venta_linea.index.cowork.description'>
                                            0<br />2
                                        </Trans>
                                    </p>
                                </span>
                                <span className="text_card_hover">
                                    <h2 className="text-primary text-heding">
                                        <Trans>venta_linea.index.cowork.title</Trans>
                                    </h2>
                                </span>
                            </div>
                        </section>
                        <section onClick={(e) => this.handleTouch(e, {
                            is_Sala: true
                        })}>
                            <div className="container_tarjet_store_desktop col-md-4" style={{
                                backgroundImage: `url(${salasImg})`
                            }}
                            // onMouseEnter={() => setIsHovered(true)}
                            // onMouseLeave={() => setIsHovered(false)}
                            >
                                <span className="text_card_hover_hover">
                                    <h2 className="text-primary text-heding">
                                        <Trans>venta_linea.index.sala.title</Trans>
                                    </h2>
                                    <p className="text-primary text-container">
                                        <Trans>venta_linea.index.sala.subtitle</Trans>
                                    </p>
                                    <p className="text-primary text-buttom">
                                        <Trans i18nKey='venta_linea.index.sala.description'>0 <br /> 2</Trans>
                                    </p>
                                </span>
                                <span className="text_card_hover">
                                    <h2 className="text-primary text-heding">
                                        <Trans>venta_linea.index.sala.title</Trans>
                                    </h2>
                                </span>
                            </div>
                        </section>
                        <section onClick={(e) => this.handleTouch(e, {
                            is_domicilio: true
                        })}>
                            <div className="container_tarjet_store_desktop col-md-4" style={{
                                backgroundImage: `url(${domicilioImg})`
                            }}>
                                <span className="text_card_hover_hover">
                                    <h2 className="text-primary text-heding">
                                        <Trans>venta_linea.index.domicilio.title</Trans>
                                    </h2>
                                    <p className="text-primary text-container">
                                        <Trans>venta_linea.index.domicilio.subtitle</Trans></p>
                                    <p className="text-primary text-buttom">
                                        <Trans i18nKey='venta_linea.index.domicilio.description'>
                                            0<br />2
                                        </Trans></p>
                                </span>
                                <span className="text_card_hover">
                                    <h2 className="text-primary text-heding">
                                        <Trans>venta_linea.index.domicilio.title</Trans></h2>
                                </span>
                            </div>
                        </section>
                    </div>
                </div>
                {/* <div className="container-movil">
                    <div className="col-md-12">
                        <button
                            className="movil-container"
                            onClick={() => this.handleIsCowork()}
                        >
                            <img alt={t('guest.store.img_calendar')} width="100%" src={coworkImg} />
                            <h2 className="text-primary text-heding">COWORK HÍBRIDO</h2>
                        </button>
                    </div>
                    <div className="col-md-12">
                        <button
                            className="movil-container"
                            onClick={() => this.handleIsSala()}
                        >
                            <img alt={t('guest.store.img_calendar')} width="100%" src={salasImg} />
                            <h2 className="text-primary text-heding">SALAS DE JUNTAS</h2>
                        </button>
                    </div>
                    <div className="col-md-12">
                        <button
                            className="movil-container"
                            onClick={() => this.setState({ is_domicilio: true })}
                        >
                            <img alt={t('guest.store.img_calendar')} width="100%" src={domicilioImg} />
                            <h2 className="text-primary text-heding">DOMICILIO COMERCIAL</h2>
                        </button>
                    </div>
                </div> */}
            </div>
        )
    }


    renderDomicilioComercialContainer = () => {
        return (
            <div className="overlay_sala container_domicilio">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <DomicilioContainer
                            center={this.state.center}
                            centerQuery={this.state.centerQuery}
                            centers={this.state.centers}
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.props.handleErrorResponse}
                            post={this.props.post}
                            post_store={this.props.postStore}
                            user={this.state.user}
                            cuidad={this.state.cuidad}
                            city={this.state.city} />
                    </div>
                </div>
            </div>
        );
    }

    renderCoworkedContainer = () => {
        return (
            <div className="overlay_sala">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <CoworkedContainer
                            center={this.state.center}
                            centerQuery={this.state.centerQuery}
                            centers={this.state.centers}
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.props.handleErrorResponse}
                            post={this.props.post}
                            post_store={this.props.postStore}
                            user={this.state.user}
                            cuidad={this.state.cuidad}
                            city={this.state.city} />
                    </div>
                </div>
            </div>
        );
    }

    renderSalasContainer = () => {
        const { t } = this.props;
        const handleSubmit = (e) => {
            e.preventDefault();
            this.props.history.push(`${URI_VENTA_EN_LINEA}/reservations`);
        }

        const groupByCity = (centers) => {
            const zones = {};
            centers.forEach(center => {
                if (!zones[center.zona]) {
                    zones[center.zona] = [];
                }
                zones[center.zona].push(center);
            });
            return zones;
        }

        const newCenters = groupByCity(this.state.centers);
        const selectOption = t('guest.store.holder_center')
        return (
            <div>
                <div className="panel-body-singup">
                    <div className="panel-body-title">
                        <h1 className="heading">{t('guest.store.heading')}</h1>
                        <h3 className="subheading">{t('guest.store.subheading')}</h3>
                    </div>
                    <form className="form-group form-grup-dektop" onSubmit={handleSubmit}>
                        <fieldset className="container-fluid">
                            <div className="row">
                                <div className="col-sm-10 col-sm-offset-1">
                                    <div className="form-group input-lg-xl">
                                        {/* <div className="input-group">
                                            <div id="dropdown-div" className="dropdown">
                                                <input
                                                    autoComplete="off"
                                                    className="dropdown-toggle form-control input-lg"
                                                    data-toggle="dropdown"
                                                    onChange={this.handleCenterSearch}
                                                    onClick={() => { $("#dropdown-div").addClass("open") }}
                                                    placeholder={t('guest.store.holder_center')}
                                                    required
                                                    type="search"
                                                    value={this.state.centerQuery}
                                                />
                                                <ul id="center-results" className="dropdown-menu" style={{ display: 'none' }}>
                                                    {this.state.centers.map((center, index) => this.renderCenter(center, index))}
                                                </ul>
                                            </div>
                                        </div> */}


                                        <div id="dropdown-div" className="dropdown">
                                            <select
                                                autoComplete="off"
                                                className="form-control input-lg"
                                                placeholder={t('guest.store.holder_center')}
                                                required
                                                onChange={this.handleCenterSearch}
                                            // value={this.state.centerQuery}
                                            >
                                                <option value="">
                                                    {selectOption}
                                                </option>

                                                {Object.keys(newCenters).map((city, index) => (
                                                    <optgroup key={index} label={city}>
                                                        {newCenters[city].map((center, index) => (
                                                            <option key={index} value={JSON.stringify(center)}>{center.name}</option>
                                                        ))}
                                                    </optgroup>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="grid-2">
                                            <div className="input-group-btn input-group-btn-movil">
                                                <button
                                                    className="btn btn-lg btn-secondary btn-full-width"
                                                    onClick={() => this.handleBack()}
                                                    type="button">
                                                    <span>
                                                        <Trans>dashboard.btn_back</Trans>
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="input-group-btn input-group-btn-movil">
                                                <button
                                                    className="btn btn-lg btn-primary btn-full-width">
                                                    <Trans>dashboard.reservations.btn_search</Trans>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div >

        )
    }

    renderRoomsContainer = () => {
        return (
            <div className="overlay_sala">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <RoomsContainer
                            center={this.state.center}
                            centerQuery={this.state.centerQuery}
                            centers={this.state.centers}
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.props.handleErrorResponse}
                            post={this.props.post}
                            post_store={this.props.postStore}
                            user={this.state.user} />
                    </div>
                </div>
            </div>
        );
    }

    renderPaymentContainer = () => {
        return (
            <div className="overlay_sala">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <PaymentContainer
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.props.handleErrorResponse}
                            post={this.props.post}
                            post_store={this.props.postStore}
                            user={this.state.user} />
                    </div>
                </div>
            </div>
        )
    }

    renderPaymentCoworkContainer = () => {
        return (
            <div className="overlay_sala">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <PaymentContainer
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.props.handleErrorResponse}
                            post={this.props.post}
                            post_store={this.props.postStore}
                            user={this.state.user} />
                    </div>
                </div>
            </div>
        )
    }

    renderRoomContainer = () => {
        return (
            <div className="overlay_sala">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <Room
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.props.handleErrorResponse}
                            post={this.props.post}
                            post_store={this.props.postStore}
                            user={this.state.user} />
                    </div>
                </div>
            </div>
        )
    }

    rebderHelperContainer = () => {
        return (
            <HelpContainer />
        )
    }

    renderDomicilioIDContainer = () => {
        return (
            <div className="overlay_sala">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <DomicilioId
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.props.handleErrorResponse}
                            post={this.props.post}
                            post_store={this.props.postStore}
                            user={this.state.user} />
                    </div>
                </div>
            </div>
        )
    }

    renderCoworkContainer = () => {
        const { t } = this.props;
        const handleSubmit = (e) => {
            e.preventDefault();
            this.props.history.push(`${URI_VENTA_EN_LINEA}/cowork`);
        }
        const selectOption = t('guest.survey.holder_city')
        return (
            <div>
                <div className="panel-body-singup">
                    <div className="panel-body-title">
                        <h1 className="heading">{t('guest.store.heading')}</h1>
                        <h3 className="subheading">{t('guest.store.subheading')}</h3>
                    </div>
                    <form className="form-group form-grup-dektop" onSubmit={handleSubmit}>
                        <fieldset className="container-fluid">
                            <div className="row">
                                <div className="col-sm-10 col-sm-offset-1">
                                    <div className="form-group">
                                        <div className="input-group input-lg-xl">
                                            <div className="form-group">
                                                <select
                                                    className="form-control input-lg"
                                                    id="city-select"
                                                    onChange={this.handleCityChange}
                                                    value={this.state.city}>
                                                    <option value="">
                                                        {selectOption}
                                                    </option>
                                                    {this.state.cuidad.map((city, index) =>
                                                        (<option key={index} className="opcion-select" value={city.id}>{city.name}</option>)
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="input-group-btn input-group-btn-movil">

                                        </div>
                                        <div className="grid-2">
                                            <button
                                                className="btn btn-lg btn-secondary btn-full-width"
                                                onClick={() => this.handleBack()}
                                                type="button">
                                                <span>
                                                    <Trans>dashboard.btn_back</Trans>
                                                </span>
                                            </button>
                                            <button
                                                className="btn btn-lg btn-primary btn-full-width">
                                                <span>
                                                    <Trans>dashboard.reservations.btn_search</Trans>
                                                </span>
                                            </button>
                                            {/* <button
                                                className="btn btn-lg btn-secondary"
                                                type="button"
                                                onClick={() => $('#btnSuccessHelp').click()}
                                            >
                                                <span>
                                                    ¿Necesitas ayuda?
                                                </span>
                                            </button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        )
    }

    renderDomicilioContainer() {
        const { t } = this.props;
        const handleSubmit = (e) => {
            e.preventDefault();
            this.props.history.push(`${URI_VENTA_EN_LINEA}/domiclioId`);
        }
        const selectOption = t('guest.survey.holder_city')
        return (
            <div>
                <div className="panel-body-singup">
                    <div className="panel-body-title">
                        <h1 className="heading">{t('guest.store.heading')}</h1>
                        <h3 className="subheading">{t('guest.store.subheading')}</h3>
                    </div>
                    <form className="form-group form-grup-dektop" onSubmit={handleSubmit}>
                        <fieldset className="container-fluid">
                            <div className="row">
                                <div className="col-sm-10 col-sm-offset-1">
                                    <div className="form-group">
                                        <div className="input-group input-lg-xl">
                                            <div className="form-group">
                                                <select
                                                    className="form-control input-lg"
                                                    id="city-select"
                                                    onChange={this.handleCityChange}
                                                    value={this.state.city}>
                                                    <option value="">
                                                        {selectOption}
                                                    </option>
                                                    {this.state.cuidad.map((city, index) =>
                                                        (<option key={index} className="opcion-select" value={city.id}>{city.name}</option>)
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="grid-2">
                                            <button
                                                className="btn btn-lg btn-secondary btn-full-width"
                                                onClick={() => this.handleBack()}
                                                type="button">
                                                <span>
                                                    <Trans>dashboard.btn_back</Trans>
                                                </span>
                                            </button>
                                            <Link to={`${URI_VENTA_EN_LINEA}/domicilio_comercial`}>
                                                <button
                                                    className="btn btn-lg btn-primary btn-full-width">
                                                    <span>
                                                        <Trans>dashboard.reservations.btn_search</Trans>
                                                    </span>
                                                </button>
                                            </Link>
                                        </div>
                                        {/* <div className="input-group-btn input-group-btn-movil">
                                            <button
                                                className="btn btn-lg btn-primary btn-singup-help"
                                                type="button"
                                                onClick={() => $('#btnSuccessHelp').click()}
                                            >
                                                <span>
                                                    ¿Necesitas ayuda?
                                                </span>
                                            </button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        )
    }

    renderNavTabsContainer = () => {
        const Sala = this.state.is_Sala ? "active" : " ";
        const Cowork = this.state.is_Cowork ? "active" : " ";
        const Domiciio = this.state.is_domicilio ? "active" : " ";

        const IsSala = this.state.is_Sala ? "tab-pane fade in active" : "tab-pane fade ";
        const IsCowork = this.state.is_Cowork ? "tab-pane fade in active" : "tab-pane fade ";
        const IsDomiciio = this.state.is_domicilio ? "tab-pane fade in active" : "tab-pane fade ";
        return (
            <div className="box-shadow container-desktop">
                <div className="panel with-nav-tabs panel-default panel-profile container-desktop-panel">
                    <ul className="nav nav-tabs">
                        <li className={Cowork}>
                            <a
                                href="#tab1default"
                                data-toggle="tab"
                                onClick={() => {
                                    this.handleBack()
                                    this.setState({ is_Cowork: true })
                                }}
                            >
                                <div className="logo-movil">
                                    <i className="fa fa-user" aria-hidden="true"></i>
                                </div>
                                <div className="text-desktop">
                                    <Trans>venta_linea.index.cowork.title</Trans>
                                </div>
                            </a>
                        </li>
                        <li className={Sala}>
                            <a
                                href="#tab2default"
                                data-toggle="tab"
                                onClick={() => {
                                    this.handleBack()
                                    this.setState({ is_Sala: true })
                                }}
                            >
                                <div className="logo-movil">
                                    <i className="fa fa-fw fa-building" aria-hidden="true"></i>
                                </div>
                                <div className="text-desktop">
                                    <Trans>venta_linea.index.sala.title</Trans>
                                </div>

                            </a>
                        </li>
                        <li className={Domiciio}>
                            <a
                                href="#tab3default"
                                data-toggle="tab"
                                onClick={() => {
                                    this.handleBack()
                                    this.setState({ is_domicilio: true })
                                }}
                            >
                                <div className="logo-movil">
                                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                                </div>
                                <div className="text-desktop">
                                    <Trans>venta_linea.index.domicilio.title</Trans>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div className="panel-body">
                        <div className="tab-content">
                            <div className={IsCowork} id="tab1default">
                                {this.renderCoworkContainer()}
                            </div>
                            <div className={IsSala} id="tab2default">
                                {this.renderSalasContainer()}
                            </div>
                            <div className={IsDomiciio} id="tab3default">
                                {this.renderDomicilioContainer()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderStoreContainer = () => {
        return (
            <div className="overlay">
                <Header handleLanguageChange={this.props.handleLanguageChange} />
                <div className="container">
                    <div className="store-singup">
                        <div className="panel-default">
                            <div className="panel-content">
                                <div className="panel_heading_store" style={{ backgroundImage: "url('" + brandLogo + "')" }}>
                                    <h1>
                                        <Trans>venta_linea.banner.title</Trans>
                                    </h1>
                                    <p>
                                        <Trans>venta_linea.banner.secondary</Trans>
                                    </p>
                                </div>
                                <div className="panel_center_store text-center">
                                    {!this.state.is_Cowork && !this.state.is_Sala && !this.state.is_domicilio ? this.renderSelectMenu() : this.renderNavTabsContainer()}
                                </div>
                            </div>
                            {this.rebderHelperContainer()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderAgradecimiento = () => {
        return (
            <AgradecimientoContainer
                getNavbarHeight={this.getNavbarHeight}
                getTokenId={this.getTokenId}
                handleErrorResponse={this.handleErrorResponse}
                handleLanguageChange={this.handleLanguageChange}
                post={this.post_summit} />
        );
    }


    renderPaymentDomicilioContainer = () => {
        return (
            <div className="overlay_sala container_domicilio">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <PaymentDomicilioContainer
                            getNavbarHeight={this.getNavbarHeight}
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.handleErrorResponse}
                            handleLanguageChange={this.handleLanguageChange}
                            post={this.props.postStore} />
                    </div>
                </div>
            </div>

        )
    }

    renderCardDomicilioConatiner = () => {

        return (
            <div className="overlay_sala container_domicilio">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid" style={{ maxWidth: "none" }}>
                        <CardDomicilioConatiner
                            getNavbarHeight={this.getNavbarHeight}
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            handleErrorResponse={this.handleErrorResponse}
                            handleLanguageChange={this.handleLanguageChange}
                            post={this.props.postStore} />
                    </div>
                </div>
            </div>

        )
    }

    renderPaymentDomicilioContainerCowork = () => {
        return (
            <div className="overlay_sala container_domicilio">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid">
                        <PaymentDomicilioContainerCowork
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            post={this.props.postStore} />
                    </div>
                </div>
            </div>
        )
    }

    renderCardCoworkConatiner = () => {
        return (
            <div className="overlay_sala container_domicilio">
                <div id="content_sala" className="container_sala">
                    <div className="container-fluid" style={{ maxWidth: "none" }}>
                        <CardCoworkConatiner
                            getTokenId={this.props.getTokenId}
                            getTokenSession={this.getTokenSession}
                            post={this.props.postStore} />
                    </div>
                </div>
            </div>
        )
    }

    renderPage = () => {
        return (
            <Switch>
                <Route exact path={URI_VENTA_EN_LINEA} component={this.renderStoreContainer} />

                {/* Rutas de Salas de juntas */}
                <Route
                    path={`${URI_VENTA_EN_LINEA}/reservations`}
                    component={this.renderRoomsContainer} />
                {/* <Route  path="/room/:roomid" component={this.renderRoomContainer} /> */}
                <Route
                    path={`${URI_VENTA_EN_LINEA}/room/:roomid/:reservationsid`}
                    component={this.renderRoomContainer} />
                <Route
                    path={`${URI_VENTA_EN_LINEA}/book/:reservationsid`}
                    component={this.renderPaymentContainer} />

                {/* Rutas de Cowork */}
                <Route
                    path={`${URI_VENTA_EN_LINEA}/cowork-info/:id`}
                    render={() => <CoworkMoreInfo
                        getTokenId={this.props.getTokenId}
                        getTokenSession={this.getTokenSession}
                        post_store={this.props.postStore}
                    />} />
                <Route
                    path={`${URI_VENTA_EN_LINEA}/cowork/coworkedpayment/payment/:coworkid/:duracionid`}
                    component={this.renderCardCoworkConatiner} />
                <Route
                    path={`${URI_VENTA_EN_LINEA}/cowork/coworkedpayment/:coworkid`}
                    component={this.renderPaymentDomicilioContainerCowork} />

                <Route
                    path={`${URI_VENTA_EN_LINEA}/cowork`}
                    component={this.renderCoworkedContainer} />

                {/* Rutas de Domicilio Comercial */}
                <Route
                    path={`${URI_VENTA_EN_LINEA}/domicilio_comercial`}
                    component={this.renderDomicilioComercialContainer} />
                <Route
                    path={`${URI_VENTA_EN_LINEA}/domiclioId/domiciliopayment/payment/:domicilioid/:duracionid`}
                    component={this.renderCardDomicilioConatiner} />

                <Route
                    path={`${URI_VENTA_EN_LINEA}/domiclioId/domiciliopayment/:domicilioid`}
                    component={this.renderPaymentDomicilioContainer} />

                {/* <Route
                    path={`${URI_VENTA_EN_LINEA}/domiclioId/:coworkid`}
                    component={this.renderDomicilioIDContainer} /> */}

                {/* Ruta de pago aprobado */}
                <Route
                    path={`${URI_VENTA_EN_LINEA}/agradecimiento`}
                    component={this.renderAgradecimiento} />

                <Route component={NotFound} />
            </Switch>
        );
    }

    render() {
        // if (this.props.user) {
        //     return <Redirect to="/store_invitado" />;
        // }
        // Cambiar el color del tema para venta en linea
        document.querySelector("meta[name='theme-color']").setAttribute("content", "#3A6063");
        return (
            <div className="strore_container_new_store">
                {this.renderPage()}
            </div>
        );
    }



}
export default translate('common')(withRouter(NewStoreContainer));


// WEBPACK FOOTER //
// ./src/store/StoreContainer.js